import { Action } from '@ngrx/store';
import { CompanyPreview } from '../interfaces/company-preview.interface';
import { Company } from '../interfaces/company.interface';
import { ActionTypes } from '../models/actionTypes';

export const SessionCompanies = (companies: CompanyPreview[]) => {
  return <Action>{ type: ActionTypes.SessionCompanies, payload: companies };
};
